import { Component, OnInit, ViewChild } from '@angular/core';
import { userType } from 'src/app/constants/global-constants';
import { INote, INoteListResponse } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { NoteService } from 'src/app/services/note.service';
import { CreateNoteComponent } from '../shared-components/create-note/create-note.component';

@Component({
  selector: 'app-note-listing',
  templateUrl: './note-listing.component.html',
  styleUrls: ['./note-listing.component.scss']
})
export class NoteListingComponent implements OnInit {

  userType = userType;
  offset: number = 0;
  limit: number = 20;
  searchText: string = '';
  notes: Array<INote> = [];
  loading: boolean;
  selectedForEdit :INote;
  @ViewChild(CreateNoteComponent) createNoteComponent: CreateNoteComponent;

  constructor(public authService: AuthService, public noteService: NoteService) { }

  ngOnInit(): void {
    this.getNoteList();
  }

  getNoteList(){
    if(this.authService.user?.userType==this.userType.MIDWIFE){
      let body = {
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true;
      this.noteService.getNotesList(body).subscribe((res: INoteListResponse)=>{
        this.notes = res.payload;
        console.log("Notes List:", this.notes);
        this.loading = false;
      },err=>{
        console.error("Notes List Error:", err);
      });
    }
  }

  searchNote(){
    if(this.authService.user?.userType==this.userType.MIDWIFE)
    {
      this.notes = [];
      let body = {
        searchPhrase: this.searchText,
        limit: this.limit,
        offset: this.offset
      }
      this.loading = true;
      this.noteService.searchNote(body).subscribe((res: INoteListResponse)=>{
        this.notes = res.payload;
        console.log("Search Notes List:", this.notes);
        this.loading = false;
      },err=>{
        console.error("Search Notes Error:", err);
      });
    }
  }

  deleteNote(noteId:number){
    this.noteService.deleteNote(noteId)
    .subscribe((res)=>{
      console.log("Note Deleted !");
      this.notes = this.notes.filter(note => note.noteId != noteId);
    },err=>{
      console.error("Delete Note Error:", err);
    });
  }

  editNote(note: INote){
    this.createNoteComponent.editNote(note);
  }

  updateNotes(note: INote){
    this.notes.forEach(res => {
      if(res.noteId == note.noteId)
      {
        res.noteText = note.noteText;
        res.noteTitle = note.noteTitle;
      }
    })
  }

}
